var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 460 460",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7F4F"
    },
    d: "M230.333,0C103.308,0,0,102.974,0,230c0,98.785,62.479,183.024,150.004,215.598l297.381-291.024 C416.25,64.595,330.94,0,230.333,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5419"
    },
    d: "M460,230c0-26.416-4.467-51.784-12.663-75.41l-44.274-44.274l-345.46,201.7l50.785,50.785 l-10.785,30.515l52.366,52.367C174.895,454.935,202.187,460,230.332,460C357.358,460,460,357.026,460,230z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#71E2F0"
    },
    points: "403.063,110.317 403.063,312.017 230.332,312.017 200.003,211.167 230.332,110.317  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C2FBFF"
    },
    points: "230.332,110.317 230.332,312.017 178.893,312.017 97.603,393.317 97.603,312.017  57.603,312.017 57.603,110.317  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C2FBFF"
    },
    points: "383.063,130.317 383.063,292.017 230.332,292.017 210.333,211.167 230.332,130.317  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.603,
    y: 130.317,
    style: {
      fill: "#FFFFFF"
    },
    width: 152.729,
    height: 161.7
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0A300"
    },
    points: "362.823,202.002 343.073,222.122 347.223,250.002 321.993,237.432 311.993,214.882  321.993,172.332 335.023,197.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC61B"
    },
    points: "321.993,172.332 321.993,237.432 296.753,250.002 300.913,222.122 281.163,202.002  308.963,197.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0A300"
    },
    points: "271.162,202.002 251.412,222.122 255.562,250.002 230.332,237.432 220.332,214.882  230.332,172.332 243.362,197.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC61B"
    },
    points: "230.332,172.332 230.332,237.432 205.092,250.002 209.252,222.122 189.502,202.002  217.302,197.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0A300"
    },
    points: "179.503,202.002 159.753,222.122 163.903,250.002 138.673,237.432 128.673,214.882  138.673,172.332 151.703,197.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC61B"
    },
    points: "138.673,172.332 138.673,237.432 113.433,250.002 117.593,222.122 97.843,202.002  125.643,197.332  "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/review.c98488494719ef0288bf773b500731b9.svg";
export { ForwardRef as ReactComponent };